
import { Component, Prop, Vue } from 'vue-property-decorator'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import TopPageNoticeContentBox from '@/components/organisms/TopPageNoticeContentBox.vue'
import { NoticeMessageData } from '@/models/NoticeMessage'

/**
 * お知らせパネル
 */
@Component({
  components: {
    PanelFrame,
    TopPageNoticeContentBox,
  },
})
export default class NoticePanel extends Vue {
  /** お知らせのリスト */
  @Prop()
  private noticeList!: NoticeMessageData[]

  /** コンテンツボックスクリック時のイベント */
  @Prop()
  private eventClickNotice!: (id: number) => void
}
